import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        header: {
            margin: 0,
            paddingInline: 0,
            paddingTop: 0,
            height: 'auto',
            marginTop: {base: remCalc(30), md: remCalc(24)},
            paddingBottom: {base: remCalc(29), md: remCalc(24)},
            borderColor: {base: 'border.dark', md: 'border.light'},
        },
        body: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingX: {base: remCalc(16), md: remCalc(24)},
        },
        headerText: {
            height: remCalc(26),
            display: 'flex',
            alignItems: 'center',
            textStyle: 'body-large',
            fontWeight: 'bold',
        },
        closeButton: {
            width: 'iconsSize.medium',
            height: 'iconsSize.medium',
            position: 'absolute',
            right: remCalc(24),
            flexShrink: 0,
        },
        border: {
            width: '100%',
            height: remCalc(4),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            marginBottom: {md: remCalc(22)},
        },
    },
    variants: {
        freeItemPromo: {
            header: {
                paddingX: {
                    base: 'small.base',
                    lg: 'small.lg',
                },
                justifyContent: 'flex-start',
                paddingInline: 'small.base',
                marginTop: remCalc(0),
                paddingTop: remCalc(24),
                height: 'auto',
            },
            headerText: {
                textStyle: {
                    base: 'body-small',
                    lg: 'body-large',
                },
                fontWeight: 'bold',
            },
            border: {
                borderBottom: 'unser',
            },
            titleContainer: {
                width: '100%',
                flexDir: 'row',
                paddingBottom: remCalc(0),
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            closeButton: {
                width: 'iconsSize.medium',
                height: 'iconsSize.medium',
                position: 'relative',
                right: remCalc(0),
                flexShrink: 0,
            },
        },
    },
}
